import React, { Component, useState } from "react";
import { Menu } from "antd";
import BasicLayout from "../../layouts/basic/BasicLayout";
import style from "./report.module.less";
import UserDayReport from "./UserDayReport";

const UserReport = () => {
    const [currentKey, setCurrentKey] = useState("day");

    const handleClick = (e) => {
        setCurrentKey(e.key);
    };

    const Report = () => {
        return currentKey == "day" ?  <UserDayReport/> : <UserDayReport />;
    }

    return (
        <BasicLayout>
            <Menu
                onClick={handleClick}
                selectedKeys={[currentKey]}
                mode="horizontal"
                className={style.menu}
                style={{ marginBottom: 15}}
            >
                <Menu.Item key="day" className={style.item}>用户日报表</Menu.Item>
            </Menu>
            <Report/>
        </BasicLayout>
    );
};

export default UserReport;
